import React from 'react'

import { CTASection } from 'components/cta-section/CTASection'
import soundscapeLogo from 'shared/assets/logos/soundscape.svg'

import type { SoundscapeCtaCmsContent } from 'core/services/cms/interfaces'

interface CTAProps {
  content: SoundscapeCtaCmsContent
}

const CTA: React.FC<CTAProps> = ({ content }) => {
  return (
    <CTASection
      logo={soundscapeLogo}
      logoAlt='Soundscape'
      text={content.text}
      backgroundImage={content.backgroundImageUrl}
    />
  )
}

export default CTA
